// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"67b9d951","463":"c1e5a4b1","621":"c5f39f83","787":"d0aae870","988":"858cfa1c"}[chunkId] + ".chunk.js";
};